module.exports = __webpack_public_path__ + "static/media/img_mobile_overseas_03.0b1fbfa1.png";